import React, { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../config/api";
import "../styles/Timings.css";

const API = API_ENDPOINTS.TIMINGS;

const Timings = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [data, setData] = useState(null);

  /* ================= FETCH FROM BACKEND ================= */

  const fetchTimings = async () => {
    try {
      const res = await fetch(API);
      const result = await res.json();
      setData(result);
    } catch (err) {
      console.error("Error fetching timings:", err);
    }
  };

  useEffect(() => {
    fetchTimings();
  }, []);

  const schedule = data?.schedule || [];
  const highlights = data?.highlights || [];
  const flow = data?.flow || [];
  const notes = data?.notes || [];

  const toggleCard = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const selectedItem =
    activeIndex !== null ? schedule[activeIndex] : null;

  return (
    <div className="temple-page">

      {/* ================= TITLE ================= */}
      <h1 className="timings-title">
        {data?.pageContent?.title || "Daily Temple Timings"}
      </h1>

      <p className="timings-subtitle">
        {data?.pageContent?.subtitle ||
          "Discover the sacred daily rituals and spiritual schedule of Sri Gnana Sai Baba Temple."}
      </p>

      {/* ================= TIMINGS GRID ================= */}
      <div className="timings-grid">
        {schedule.map((item, index) => {
          const isActive = activeIndex === index;

          return (
            <div
              key={index}
              className={`timing-card ${isActive ? "active" : ""}`}
              onClick={() => toggleCard(index)}
            >
              <div className="time">{item.time}</div>
              <div className="activity">{item.activity}</div>

              {isActive && (
                <div className="description">
                  {item.description}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ================= DETAIL VIEW ================= */}
      <div className="full-description-section">
        {selectedItem ? (
          <div className="description-card">
            <h2>{selectedItem.activity}</h2>
            <p className="desc-time">⏰ {selectedItem.time}</p>
            <p className="desc-text">{selectedItem.description}</p>
          </div>
        ) : (
          <div className="description-card empty">
            <h2>Temple Daily Schedule</h2>
            <p>Click any timing to view detailed ritual information.</p>
          </div>
        )}
      </div>

      {/* ================= HIGHLIGHTS ================= */}
      <div className="timing-highlights">
        <h2>🌟 Temple Highlights of the Day</h2>

        <div className="highlight-grid">
          {highlights.map((item, i) => (
            <div className="highlight-card" key={i}>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= DAILY FLOW ================= */}
      <div className="daily-flow">
        <h2>🌞 Temple Daily Flow</h2>

        <div className="flow-timeline">
          {flow.map((item, i) => (
            <div className="flow-item" key={i}>
              <span>{item.title}</span>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ================= SPIRITUAL NOTES ================= */}
      <div className="ritual-notes">
        <h2>📿 Spiritual Significance</h2>

        {notes.map((note, i) => (
          <div className="note-card" key={i}>
            <p>{note}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Timings;